import { Button } from '@consta/uikit/Button'
import { Modal } from '@consta/uikit/Modal'
import { Table } from '@consta/uikit/Table'
import { Text } from '@consta/uikit/Text'
import { FC } from 'react'
import { IconClose } from '@consta/icons/IconClose'
import { IconCheck } from '@consta/icons/IconCheck'

type AddWells = {
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void
    handleCloseModal: () => void;
}

//@ts-ignore
const AddWells: FC<AddWells> = ({ isOpen, setIsOpen, handleCloseModal }) => {


    return (
        <div>
            <Modal
                isOpen={isOpen}
                hasOverlay
                onClickOutside={handleCloseModal}
                onEsc={handleCloseModal}
            >
                <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text size='xl' weight='bold' style={{ display: 'flex' }}>Добавить скважину</Text>
                        <Button size='s' iconLeft={IconClose} view='clear' onClick={handleCloseModal} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'end', gap: '20px' }}>
                       
                    </div>
                </div>
            </Modal >
        </div >
    )
}

export default AddWells